import type { PromoConfig } from 'shared/lib/promo/common';

export type FeaturesResponse = {
  promo?: PromoConfig[];
  flags?: {
    /**
     * shows sandbox switch for individual companies
     */
    sandbox_switch_individual_company?: boolean;

    /**
     * shows coverage request button & modal
     */
    coverage_request?: boolean;

    /**
     * shows paygo refresh button
     */
    show_paygo_refresh?: boolean;
  };
};

export enum FeatureFlag {
  KNOCK_NOTIFICATIONS = 'knock-notifications',
  UPGRADE_PROMO_LAYOUT = 'upgrade-promo-layout',
  AI_ASSISTANT = 'ai-assistant',
  TEMPLATE_BANK_STATEMENTS = 'template-bank-statements',
  TEMPLATE_DOC_UPLOAD_COLLECTIONS = 'template-doc-upload-collections',
}

export enum FeatureFlagVariant {
  CONTROL = 'control',
  ALTERNATIVE = 'alternative',
}

/** Shape of the `feature_flags` citadel returns on a bridge token. */
export type BridgeFeatureFlags = Record<string, { value: string; payload?: unknown } | undefined>;

/** Experiments citadel evaluates per bridge token, named as the widget knows them. */
export enum BridgeExperiment {
  /** The 2026 order landing page. Its single-product layout shows a product name; the old one does not. */
  ORDER_PAGE_2026 = 'ab-order-page-2026',
}

/**
 * Reads a citadel experiment off a bridge token.
 *
 * Only meaningful for an experiment rolled out to a single 100% variant, gated by a client-level
 * targeting rule — which is how ab-order-page-2026 is configured. Citadel seeds the variant *split*
 * on the applicant, and the dashboard mints a throwaway applicant per preview, so an experiment with
 * two live variants would answer differently on every page load. An excluded client drops out of the
 * response entirely, hence "absent" reads the same as "off".
 */
export const isBridgeExperimentEnabled = (
  featureFlags: BridgeFeatureFlags | undefined,
  experiment: BridgeExperiment,
): boolean => featureFlags?.[experiment]?.value === FeatureFlagVariant.ALTERNATIVE;

export enum UpgradePromoLayoutVariant {
  MODAL = 'modal',
  TOAST = 'toast',
}
